import { RouteDriverUpdateDtoModelType } from '../../models';
import getAppRoot from '../../utils/getAppRoot';

/**
 * Driver assignment is route-scoped for GPS. When the assigned driver changes, drop the prior
 * driver's last location so the new assignee does not inherit an "online" indicator.
 */
export default ({ store, route }: RouteDriverUpdateDtoModelType) => () => {
  if (route?.id == null) {
    return;
  }

  const rootStore = getAppRoot(store);
  rootStore.driverLocation.clearRouteLocation(route.id);

  // RouteDriverUpdate query does not refetch lastLocation; clear the MST seed so a later
  // driverLocation.start() cannot resurrect the previous driver's ping.
  if (route.lastLocation != null) {
    route.clearLastLocation();
  }
};
